import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { CurrencyMaskModule } from 'ng2-currency-mask';
import { PipesModule } from '../pipes/pipes.module';

import { DirectivesModule } from '../directives/directives.module';
import { AberturaCaixaDialogComponent } from './abertura-caixa-dialog/abertura-caixa-dialog.component';
import { AceitarRejeitarPedidoDeliveryDialogComponent } from './aceitar-rejeitar-pedido-delivery-dialog/aceitar-rejeitar-pedido-delivery-dialog.component';
import { CadastroClientesComponent } from './cadastro-clientes/cadastro-clientes.component';
import { EnderecoClienteComponent } from './cadastro-clientes/endereco-cliente/endereco-cliente.component';
import { AbaGeralCadastroProdutosComponent } from './cadastro-produtos-dialog/aba-geral-cadastro-produtos/aba-geral-cadastro-produtos.component';
import { AbaMacarraoCadastroProdutosComponent } from './cadastro-produtos-dialog/aba-macarrao-cadastro-produtos/aba-macarrao-cadastro-produtos.component';
import { AbaPizzaCadastroProdutosComponent } from './cadastro-produtos-dialog/aba-pizza-cadastro-produtos/aba-pizza-cadastro-produtos.component';
import { CadastroProdutosDialogComponent } from './cadastro-produtos-dialog/cadastro-produtos-dialog.component';
import { ConfiguracaoManualDialog } from './configuracao-manual/configuracao-manual.dialog';
import { DeleteButtonComponent } from './delete-button/delete-button.component';
import { AreaCartaoComponent } from './escolher-forma-pgto-dialog/area-cartao/area-cartao.component';
import { AreaTrocoComponent } from './escolher-forma-pgto-dialog/area-troco/area-troco.component';
import { EscolherFormaPgtoDialogComponent } from './escolher-forma-pgto-dialog/escolher-forma-pgto-dialog.component';
import { FechamentoCaixaDialogComponent } from './fechamento-caixa-dialog/fechamento-caixa-dialog.component';
import { InfoPedidoComponent } from './info-pedido/info-pedido.component';
import { LocalizarClientesComponent } from './localizar-clientes/localizar-clientes.component';
import { MontarItemComponent } from './montar-item/montar-item.component';
import { NavbarComponent } from './navbar/navbar.component';
import { ObservacoesProdutoComponent } from './observacoes-produto/observacoes-produto.component';
import { OutrasOperacoesPopover } from './outras-operacoes/outras-operacoes.popover';
import { PagarContaComponent } from './pagar-conta/pagar-conta.component';
import { ProdutosPedidoTableComponent } from './produtos-pedido-table/produtos-pedido-table.component';
import { QrScannerDialogComponent } from './qr-scanner-dialog/qr-scanner-dialog.component';
import { SelecionarEnderecoDeliveryDialogComponent } from './selecionar-endereco-delivery-dialog/selecionar-endereco-delivery-dialog.component';
import { SelecionarProdutoComponent } from './selecionar-produto/selecionar-produto.component';
import { SelecionarQtdFatiasDialog } from './selecionar-qtd-fatias/selecionar-qtd-fatias.dialog';
import { SelecionarStatusComponent } from './selecionar-status/selecionar-status.component';
import { TransferenciaMesaComponent } from './transferencia-mesa/transferencia-mesa.component';
import { AreaPixComponent } from './escolher-forma-pgto-dialog/area-pix/area-pix.component';
import { ManutencaoMesasDialogComponent } from './manutencao-mesas-dialog/manutencao-mesas-dialog.component';
import { SangriaSuprimentoDialogComponent } from './sangria-suprimento-dialog/sangria-suprimento-dialog.component';
import { ValorRecebidoTrocoDialogComponent } from './valor-recebido-troco-dialog/valor-recebido-troco-dialog.component';
import { ConfirmarUsuarioDialogComponent } from './confirmar-usuario-dialog/confirmar-usuario-dialog.component';
import { ProdutoQtdeVendaDialogComponent } from './produto-qtde-venda-dialog/produto-qtde-venda.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { CabecalhoComponent } from './cabecalho/cabecalho.component';
import { ConfiguracaoPedidoDialogComponent } from './configuracao-pedido-dialog/configuracao-pedido-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { CadastroPerguntasPage } from 'src/app/pages/cadastro-perguntas/cadastro-perguntas.page';
import { MatTableModule } from '@angular/material/table';
import { QtdSaboresFatiasComponent } from './qtd-sabores-fatias/qtd-sabores-fatias.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { GrupoComponent } from './grupo/grupo.component';
import { MatButtonModule } from "@angular/material/button";
import { SubGrupoComponent } from './sub-grupo/sub-grupo.component';
import { CadastroPizzaLasanhaComponent } from './cadastro-pizza-lasanha/cadastro-pizza-lasanha.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AdicionaisProdutoComponent } from './adicionais-produto/adicionais-produto.component';
import { IngredientesProdutoComponent } from './ingredientes-produto/ingredientes-produto.component';
import { CadastroAdicionaisPage } from 'src/app/pages/cadastro-adicionais/cadastro-adicionais.page';
import { CadastroIngredientesPage } from 'src/app/pages/cadastro-ingredientes/cadastro-ingredientes.page';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
    declarations: [
        MontarItemComponent,
        ObservacoesProdutoComponent,
        PagarContaComponent,
        SelecionarProdutoComponent,
        TransferenciaMesaComponent,
        SelecionarStatusComponent,
        CadastroClientesComponent,
        EnderecoClienteComponent,
        InfoPedidoComponent,
        LocalizarClientesComponent,
        QrScannerDialogComponent,
        ConfiguracaoManualDialog,
        NavbarComponent,
        OutrasOperacoesPopover,
        DeleteButtonComponent,
        SelecionarQtdFatiasDialog,
        CadastroProdutosDialogComponent,
        GrupoComponent,
        ProdutosPedidoTableComponent,
        AceitarRejeitarPedidoDeliveryDialogComponent,
        AbaGeralCadastroProdutosComponent,
        AbaPizzaCadastroProdutosComponent,
        AbaMacarraoCadastroProdutosComponent,
        FechamentoCaixaDialogComponent,
        EscolherFormaPgtoDialogComponent,
        AreaCartaoComponent,
        AreaTrocoComponent,
        AreaPixComponent,
        SelecionarEnderecoDeliveryDialogComponent,
        AberturaCaixaDialogComponent,
        ManutencaoMesasDialogComponent,
        SangriaSuprimentoDialogComponent,
        ProdutoQtdeVendaDialogComponent,
        ValorRecebidoTrocoDialogComponent,
        ConfirmarUsuarioDialogComponent,
        CabecalhoComponent,
        ConfiguracaoPedidoDialogComponent,
        CadastroPerguntasPage,
        QtdSaboresFatiasComponent,
        SubGrupoComponent,
        CadastroPizzaLasanhaComponent,
        AdicionaisProdutoComponent,
        IngredientesProdutoComponent,
        CadastroAdicionaisPage,
        CadastroIngredientesPage,
    ],
    imports: [
        CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        CurrencyMaskModule,
        PipesModule,
        DirectivesModule,
        MatMenuModule,
        MatIconModule,
        MatDialogModule,
        MatSlideToggleModule,
        MatButtonToggleModule,
        MatProgressSpinnerModule,
        MatChipsModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        MatInputModule,
        MatTableModule,
        MatExpansionModule,
        MatTabsModule,
        MatButtonModule,
        MatTooltipModule,
    ],
    exports: [
        MontarItemComponent,
        ObservacoesProdutoComponent,
        PagarContaComponent,
        SelecionarProdutoComponent,
        TransferenciaMesaComponent,
        SelecionarStatusComponent,
        CadastroClientesComponent,
        InfoPedidoComponent,
        LocalizarClientesComponent,
        QrScannerDialogComponent,
        NavbarComponent,
        DeleteButtonComponent,
        EscolherFormaPgtoDialogComponent,
        SelecionarEnderecoDeliveryDialogComponent,
        SangriaSuprimentoDialogComponent,
        CabecalhoComponent,
        ConfiguracaoPedidoDialogComponent,
        CadastroPerguntasPage,
        QtdSaboresFatiasComponent,
        GrupoComponent,
        SubGrupoComponent,
        CadastroPizzaLasanhaComponent,
        AdicionaisProdutoComponent,
        IngredientesProdutoComponent,
        CadastroAdicionaisPage,
        CadastroIngredientesPage,
    ]
})
export class ComponentsModule { }
